// extracted by mini-css-extract-plugin
module.exports = {"fahidWhatsAppLogo":"style_fahidWhatsAppLogo__D8WXE","fahidWhatsAppLogo__element":"style_fahidWhatsAppLogo__element__Zv69J"};